import React from 'react';
import { Head } from '@inertiajs/react';
import { Button } from '@/components/ui/button';

const Index: React.FC = () => {
  const handleSignIn = () => {
    window.location.href = '/auth/google_oauth2';
  };

  return (
    <>
      <Head title="Flow Studio" />
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
        <div className="max-w-md w-full space-y-8">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-slate-900 mb-2">Flow Studio</h1>
            <p className="text-lg text-slate-600 mb-8">
              Workflow management and visualization platform
            </p>
            <div className="space-y-4">
              <Button
                onClick={handleSignIn}
                className="w-full py-3 px-6 text-lg font-medium"
                size="lg"
              >
                Sign in with Google
              </Button>
              <p className="text-sm text-slate-500">Sign in with your GrowthX Google account</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
